var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4551C24.8366 32.4551 32 25.2916 32 16.4551C32 7.61852 24.8366 0.455078 16 0.455078C7.16344 0.455078 0 7.61852 0 16.4551C0 25.2916 7.16344 32.4551 16 32.4551Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3443 13.5287L16.6571 15.3378L18.7832 14.6484L17.4683 16.4559L18.7809 18.2649L16.6556 17.5729L15.3408 19.3804L15.3422 17.1453L13.2168 16.4533L15.3429 15.764L15.3443 13.5287Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7618 20.9768C9.26458 20.9768 7.24008 18.9523 7.24008 16.455C7.24008 13.9578 9.26458 11.9333 11.7618 11.9333C12.5405 11.9333 13.2731 12.1302 13.9127 12.4768C12.9093 11.4954 11.537 10.8898 10.0227 10.8898C6.94908 10.8898 4.45752 13.3814 4.45752 16.455C4.45752 19.5285 6.94914 22.0201 10.0227 22.0201C11.5371 22.0201 12.9093 21.4145 13.9127 20.4331C13.2731 20.7798 12.5405 20.9768 11.7618 20.9768V20.9768Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.16b85465.svg";
export { ForwardRef as ReactComponent };